<!-- 收货地址 -->
<template>
  <BaseFormItem2
    class="address"
    :label="fields.label"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <!-- 未登录 -->
    <NotLogin v-if="!isLogin" :isError="isError" text="请登录获取收货地址" />
    <template v-else>
      <!-- 没数据 -->
      <BaseEmpty 
        v-if="!address || !address.id"
        text="还没有收货地址" 
        btnText="+新增一个" 
        :isError="isError"
        @btnClick="handleAdd" 
      />
      <div v-else class="address-content">
        <div class="address-item">
          <img 
            class="address-item__icon"
            :src="require('@@/assets/img/icons/icon_address.png')" 
          />
          <div class="address-item__content">
            <div class="address-item__content__user">
                <p>{{ address.consignee }}</p>
                <p>{{ address.telMobile }}</p>
                <span v-if="address.isDefault == 1">默认</span>
            </div>
            <div class="address-item__content__address">
              {{ address.combinAddr }} {{ address.addr }}
            </div>
          </div>
          <div class="address-item__btn" @click="handleSwitchAddress">
            更换
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="address-add">
          <BaseTextButton 
            class="address-btn"
            :plain="false"
            :light="true" 
            @click="handleAdd"
          >
            <i class="el-icon-circle-plus-outline" />
            新增
          </BaseTextButton>
        </div>
      </div>
    </template>

    <!-- 切换地址弹框 -->
    <SwitchAddress ref="SwitchAddress" @succ="handleChange"/>
    <!-- 添加地址弹框 -->
    <AddAddress ref="AddAddress" @succ="handleChange"/>
  </BaseFormItem2>
</template>

<script>
// 未登录
import NotLogin from '@@/views/pcbQuote/components/notLogin'
// 切换地址弹框
import SwitchAddress from '@@/components/address/switchAddress'
// 添加地址弹框
import AddAddress from '@@/components/address/addAddress'

import { isLogin } from '@@/utils/is'
import { getFR4Fields } from '@@/utils/getFields'
import { getNewAddressList } from '@@/api/customer'

export default {
  props: {
    // 地址id
    aid: {
      type: [Number, String],
      default: ''
    },
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NotLogin,
    SwitchAddress,
    AddAddress
  },
  data() {
    return {
      address: {},
      list: [],
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('aid')
    },
    isLogin() {
      return isLogin()
    }
  },
  watch: {
    // initPcbParamsChange(newVal) {
    //   if (this.isLogin && !newVal) {
    //     this.init()
    //   }
    // }
  },
  // mounted() {
  //   this.init()
  // },
  methods: {
    init() {
      if (!this.isLogin) return
      this.getList()
    },
    handleChange(data) {
      this.address = data
      this.$emit('change', data)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
    getList() {
      getNewAddressList({
        pageNum: 1,
        pageSize: 10
      })
        .then(res => {
          if (!res) return
          const { suc, body = [] } = res
          if (suc) {
            this.list = body || []
            this.selectDefault()
          }
        })
    },
    // 已选时 > 默认 > 第一个
    selectDefault() {
      const { aid, list } = this
      if (list && list.length > 0) {
        const item = aid && list.find(i => i.id == aid)
        const defaultItem = list.find(i => i.isDefault)
        this.handleChange(item || defaultItem || list[0])
      }
    },
    // 切换地址
    handleSwitchAddress() {
      this.$refs.SwitchAddress.showList(this.aid)
    },
    // 新增地址
    handleAdd() {
      this.$refs.AddAddress.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.address {
  ::v-deep .base-form-item__content {
    width: calc(100% - 110px);
  }
}
.address-content {
  display: flex;
  align-items: center;
  .address-add {
    position: relative;
    margin-left: 12px;
    &::before {
      content: '';
      position: absolute;
      left: -12px;
      top: 50%;
      display: block;
      width: 12px;
      height: 1px;
      background-color: $--form-color-base;
    }
  }
}
.address-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
  padding: 12px;
  border-radius: $--border-radius-base2;
  border: 1px solid $--form-color-base;
  background-color: #F7FCFB;
  &::after {
    content: '';
    position: absolute;
    right: -1px;
    bottom: -1px;
    display: block;
    width: 14px;
    height: 13px;
    background: url(~@@/assets/img/icons/icon_radio2.png);
  }

  .address-item__icon {
    display: block;
    margin-right: 12px;
    width: 16px;
    height: 16px;
  }

  .address-item__content {
    flex: 1;
    .address-item__content__user {
      display: flex;
      margin-bottom: 6px;
      line-height: 19px;
      font-size: 14px;
      color: #555555;
      >p {
        margin-right: 10px;
      }
      >span {
        display: inline-block;
        width: 36px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: $--color-warning;
        text-align: center;
        border-radius: 2px;
        background-color: #FDF6EC;
      }
    }
    .address-item__content__address {
      display: flex;
      line-height: 19px;
      font-size: 14px;
      color: #111111;
    }
  }

  .address-item__btn {
    flex-shrink: 0;
    width: 50px;
    font-size: 12px;
    color: #999999;
    text-align: right;
    cursor: pointer;
    &:hover {
      color: $--form-color-base; 
    }
  }
}
</style>